import axios from '@/libs/api.request'
import config from '@/config'

const baseUrl = config.workSheetApi + '/worksheet/api/v1/'

export const GetWorkSheetType = (params) => {
  return axios.request({
    url: baseUrl + 'worksheet_type/',
    params: params,
    method: 'get'
  })
}

export const GetWorkSheetSonType = (params) => {
  return axios.request({
    url: baseUrl + 'worksheet_son_type/',
    params: params,
    method: 'get'
  })
}

export const GetALLWorkSheetType = (params) => {
  return axios.request({
    url: baseUrl + 'all_worksheet_type_list/',
    params: params,
    method: 'get'
  })
}

export const getTypeNameList = () => {
  return axios.request({
    url: baseUrl + 'all_type_name_list/',
    method: 'get'
  })
}

export const GetALLWorkSheetTypeSon = (params) => {
  return axios.request({
    url: baseUrl + 'all_worksheet_type_list_son/',
    params: params,
    method: 'get'
  })
}

export const ChangeWorkSheetType = (data, id) => {
  let url = baseUrl + 'worksheet_type/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const ChangeWorkSheetTypeSon = (data, id) => {
  let url = baseUrl + 'worksheet_son_type/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const DeleteWorkSheetType = (id) => {
  return axios.request({
    url: baseUrl + 'worksheet_type/' + id + '/',
    method: 'delete'
  })
}

export const DeleteWorkSheetTypeSon = (id) => {
  return axios.request({
    url: baseUrl + 'worksheet_son_type/' + id + '/',
    method: 'delete'
  })
}
